import $ from 'jquery';

$(document).ready(function () {
  acfLocationBlock();
});

function acfLocationBlock() {
  $('.js-acf-example-block').each(function () {});
}
